import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export function bomItemThumbnailSelector(
  state: RootAppState,
  bomItemId: string,
  preferTreeView?: boolean,
  get2dFilename?: boolean
): string {
  const bomItem = bomItemSelector(state, bomItemId, preferTreeView)

  if (!bomItem?.type) {
    return undefined
  }

  switch (bomItem?.type) {
    case 'Assembly':
      return bomItem.hasGeometry ? undefined : bomItem.thumbnail3d
    case 'Row':
      return get2dFilename
        ? bomItem.thumbnail2d || undefined
        : bomItem.thumbnail3d || undefined
  }

  return undefined
}
